<template>
  <v-container>
<!--    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>-->
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <AboutLayout1 v-if="form && form.template === 1 && showTemplate" />
    <AboutLayout2 v-if="form && form.template === 2 && showTemplate" />
    <v-row id="about-expand" class="mt-3" >
      <v-col>
        <AboutExpandable mode="about" :state="routeHash && routeHash === '#network' ? 4:routeHash && routeHash === '#contact' ? 6:null" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AboutLayout1 from "./layout/AboutLayout1";
import AboutLayout2 from "./layout/AboutLayout2";
import AboutExpandable from "../../components/expandables/AboutExpandable";
import { mapState } from "vuex";
import Loading from 'vue-loading-overlay';

export default {
  components: {
    AboutLayout1,
    AboutLayout2,
    AboutExpandable,
    Loading
  },
  methods: {
    fullHandler() {
      this.visibleFull = true;
    }
  },
  computed:{
    ...mapState({
      form: state => {
        return state.About.form;
      },
      branchName: state => state.Branch.branch_name,
      branchId: state => state.Branch.branch_id,
      lang: state => state.Branch.lang
    }),
    branchChanged: function () {
      return this.branchName;
    },
    routeHash: function () {
      return this.$route.hash;
    }
  },
  watch: {
    branchChanged: function() {
      this.items[0].text = this.branchChanged;
      if (this.branchId === 0) {
          return this.$router.push('/about-main');
      }
      this.isLoading = true;
        // console.log('see id', this.branchId);
      if (this.branchId === 5) {
          this.$store.dispatch('Branch/getMiniByBranch', { branch_id: this.branchId, lang: this.lang });
      }
      this.$store.dispatch("About/getAboutAllMenu", { branch_id: this.branchId, lang: this.lang });
      this.$store.dispatch("About/getAboutById",{
          id: this.branchId,
          lang: this.lang
      }).then(async res => {
          if (res.response_code === 200) {
              await this.$store.dispatch("About/setFormAbout", res.result);
              if (this.branchId === 5) {
                  // this.isLoading = false;
                  // this.$forceUpdate();
                  this.$router.push(`/about/mini-tcdc/${res.result.branch_id}`);
              } else {
                  // this.isLoading = false;
                  // this.$forceUpdate();
                  this.$router.push(`/about/${res.result.branch_id}`);
              }
              this.showTemplate = false;
          } else {
              console.log('data not found');
          }
          this.isLoading = false;
      }).then(() => {
          this.showTemplate = true
      });
    },
    form: function() {
      if (this.form && this.form.template === 3) {
        this.$router.push('/about/mini-tcdc/3');
      }
    },
    routeHash: async function () {
      if (this.routeHash) {
        await new Promise(x => setTimeout(x, 1000));
        this.$vuetify.goTo('#about-expand');
      }
    }
  },
  created() {
    this.items[0].text = this.branchName;
    if (this.form.branch_id !== this.$route.params.branch_id) {

      this.$store.dispatch("About/getAboutById",{
        id: this.$route.params.branch_id,
        lang: this.lang
      }).then(res => {
        if (res.response_code == 200) {
          this.$store.dispatch("About/setFormAbout", res.result);
        } else {
          console.log('data not found');
        }
      });
    }
    // if (this.form && this.form.branch){
    //   this.items[0].text = this.form.branch.branch_name
    // }
  },
  async mounted() {
    if (this.routeHash) {
      await new Promise(x => setTimeout(x, 1000));
      this.$vuetify.goTo('#about-expand');
    }
  },
  data: () => ({
      showTemplate: true,
    items: [
      {
        text: 'TCDC BANGKOK',
        to: "/home"
      },
      {
        text: "ABOUT",
        to: '/about-main'
      }
    ],
    visibleFull: false,
    isLoading: false,
    events: [
      {
        name: "master of materials",
        time: "14 Aug - 13 Oct 2019",
        place: "TCDC Bangkok",
        highlight: false
      },
      {
        name: "master of materials",
        time: "14 Aug - 13 Oct 2019",
        place: "TCDC Bangkok",
        highlight: false
      },
      {
        name: "master of materials",
        time: "14 Aug - 13 Oct 2019",
        place: "TCDC Bangkok",
        highlight: false
      },
      {
        name: "master of materials",
        time: "14 Aug - 13 Oct 2019",
        place: "TCDC Bangkok",
        highlight: false
      }
      // 4 และ highlight
    ],
  })
};
</script>

<style></style>
